// import styles from './Copyright.module.css';

const Copyright = props => {
  return (
    <small className={props.className ? props.className : ''}><strong>Copyright &copy; Nerd DAO {new Date().getFullYear()}</strong></small>
  );
};

export default Copyright;